export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('nav-trigger-active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if( $(window).width() < 960 ) {
      if (!$(event.target).closest('.js-nav').length) {
        if ($('.sub-menu').is(":visible")) {
          $('.sub-menu').slideUp(speed);
          $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
        }
      }
    }
  });

  // Header logo

  var stickyHeader = function() {
    var y = $(window).scrollTop();
    if ( y > 0 ) {
      $('header').addClass('stick');
      if( $('body').hasClass('home') ) {
        $('.js-header-logo').removeClass('hidden');
        $('.js-header-logo').addClass('block');
      }
    } else {
      $('header').removeClass('stick');
      if( $('body').hasClass('home') ) {
        $('.js-header-logo').removeClass('block');
        $('.js-header-logo').addClass('hidden');
      }
    }
  }

  stickyHeader();

  $(document).scroll(function() {
    stickyHeader();
  });


  // Display nav items if window resize to desk

  $(window).resize(function() {
    if( $(window).width() > 960 ) {
      $('.js-nav-items').css('display', 'flex');
    } else {
      $('.js-nav-items').hide();
    }
  })

  // Back to top

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
